import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GiftcardsComponent } from './giftcards.component';

const routes: Routes = [
  {
    path: '',
    component: GiftcardsComponent,
    data: {
      title: 'Gift Cards',
      description: `Gift cards and gifts for holidays, birthdays, weddings, etc.`
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GiftcardsRoutingModule {}
